import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from "reactstrap";
import Service from "src/api/Service"
import dashboard from 'src/assets/dashboard.svg'

function MiniKpi(props){

  const [form, setForm] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [countFilter, setCountFilter] = useState(false);

  const [Data, setData] = useState([]);
  console.log(props)
 
  function getData(){
    Service.get("config/tabPASummary/"+props.prams.keyname,(status,data)=>{
   
        // console.log(data)
        if(status==200){
          setData(data);
          setisLoading(false);
        }
    }); 
  }
  useEffect(() => {
    getData();

  },[]);

  function filterSummary(filterData){   
       var obj ={};
       obj['data']=filterData;
       obj['keyname']=props.prams.keyname;
       console.log(obj)
        Service.post("config/tabPASummary/getFilterData",obj,(status,data)=>{               
     
          console.log(data)
          if(status==200){
            setData(data);
          
          }
      });
  }

  if(props.filterData.length == undefined  && countFilter != props.countFilter){
    setCountFilter(props.countFilter);
    filterSummary(props.filterData);
  }
  if(isLoading){
    return (<div>...</div>);
  }
  if(Data.length==0){
    return (<div>...</div>);
  }


  return(
    <>
         <div className='componentICON' ><div className='row'> <div className='col-sm-3' style={{marginLeft:'8px'}}>
           <img className='card' style={{backgroundColor:props.prams.backgroundColor ,padding:'10px',marginTop:'-30px'}} src={dashboard} />
           </div> <div className='col-sm-8' style={{marginLeft:'-16px'}}>  <span className='componentNameC' style={{background:props.prams.backgroundColor}} >{props.prams.component} </span></div></div></div>
    
        <div className='p-2' style={{padding:'0.0rem !important'}}>
        <Row key={props.prams.keyname}>
            
          {/* <div className="col-sm top_select" >
          <Select2 
                  id={form[0][0]}
                  label={form[0][1]['label']}
                  validation={form[0][1]['validation']}
                  remote_source={form[0][1]['remote-source']}
                  onChange={(e)=>{
                   
                    setLocation(e.value)
                     filterSummary(e.value,SelectionId);
                  }}
                  error={[]}
                  />
          </div>     */}
{/* 
          <div className="col-sm top_select" >
             <Select2 
                  id={form[1][0]}
                  label={form[1][1]['label']}
                  validation={form[1][1]['validation']}
                  remote_source={form[1][1]['remote-source']}
                  error={[]}
                  onChange={(e)=>{
                   
                    setSelectionId(e.value);
                    filterSummary(Location, e.value);
                  }}
                  />
          </div>          */}
         
          <div className="col-sm topcard" style={{textAlign: 'left'}}>
          <p className="cardClass"><span className='font20' style={{fontSize:'23px',color:props.prams.backgroundColor ,fontWeight: '500',marginLeft:'8px'}}>{Data[0]['Planned_Qty']}</span></p>
          <h5 style={{fontSize:'15px', marginTop:'-10px',color:props.prams.backgroundColor,fontWeight: '500', marginLeft:'8px'}}>Planned Quantity &nbsp;  </h5>
        
          </div>                  

          <div  className="col-sm topcard" style={{textAlign: 'Right'}}>
          <p className="cardClass"><span className='font20' style={{fontSize:'23px',color:props.prams.backgroundColor,fontWeight: '500',marginRight:'8px'}}>{Data[0]['Actual_Qty']}</span></p>
          <h5 style={{fontSize:'15px', marginTop:'-10px',color:props.prams.backgroundColor,fontWeight: '500'}}>Actual Quantity &nbsp;  </h5>
       
            
          </div>       
          <div style={{ display: "flex", alignItems: "center" }}>
    <div style={{ flex: 1, backgroundColor: '#d2d2d6',color:props.prams.backgroundColor, height: ".5px", marginTop:"0px" }} />
          </div>
          <p style={{fontSize:'15px',fontWeight: '500',color:props.prams.backgroundColor, marginTop:'5px', marginLeft:'8px'}}><i className="fa fa-calendar" aria-hidden="true"></i>&nbsp; Last 1 Week &nbsp;  </p>
          {/* <div  className="col-sm topcard">
            <h6>200k &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;<span style={{color :'red'}}> 69%</span></h6>
             <span>Inventory @ Stockist</span>
          </div>       

          <div  className="col-sm topcard">
            <h6>2.1 Cr &nbsp;&nbsp;&nbsp;&nbsp; 7 %</h6>
             <span>Expiry Vale YTD</span>
          </div>        */}

          </Row>

        </div>
          
     
    </>
  )
}
export default MiniKpi



